// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__iBkAi","bigColWidth":"Table_bigColWidth__3h8m9","biggerColWidth":"Table_biggerColWidth__1HpMQ","row":"Table_row__2pB5t","col":"Table_col__1ydqt"};